import React, { Fragment, useState, useEffect } from 'react'
import PageLayout from './PageLayout'
import Helmet from 'react-helmet'
import map from 'lodash/map'
import get from 'lodash/get'
import { SECTIONS } from '../../utils/url'
import BlogStoryBlockWidget from '../blogWidgets/StoryBlockWidget'
import BlogLinkWidget from '../blogWidgets/BlogLinkWidget'

export default (props) => {
    const { sitemap, className, blog } = props
    const activeSection = get(blog, 'userSection', '')
    const description = get(blog, 'description.description', '')
    const firstArticle = get(blog, 'articles.0', null)
    const articlesList = get(blog, 'articles', []).slice(1)
    const [currentPage, setCurrentPage] = useState(1)

    const BASE_ITEMS_PER_PAGE = 8
    const ADDITIONAL_ITEMS = 4
    const FEATURED_ITEM = 0

    // Calculate items per page based on current page
    const itemsPerPage = currentPage === 1 ? BASE_ITEMS_PER_PAGE : BASE_ITEMS_PER_PAGE + ADDITIONAL_ITEMS

    // Calculate total pages considering the different number of items per page
    const remainingItems = articlesList?.length - FEATURED_ITEM - BASE_ITEMS_PER_PAGE
    const remainingPages = Math.ceil(remainingItems / (BASE_ITEMS_PER_PAGE + ADDITIONAL_ITEMS))
    const totalPages = remainingItems > 0 ? remainingPages + 1 : 1

    // Calculate start and end indices
    const startIndex = currentPage === 1
        ? FEATURED_ITEM
        : FEATURED_ITEM + BASE_ITEMS_PER_PAGE + ((currentPage - 2) * (BASE_ITEMS_PER_PAGE + ADDITIONAL_ITEMS))
    const endIndex = startIndex + itemsPerPage
    const currentArticles = articlesList?.slice(startIndex, endIndex)
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    // Effect to handle scrolling when page changes
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [currentPage]);

    const renderPagination = () => {
        if (totalPages <= 1) return null;

        const goToPreviousPage = () => {
            if (currentPage > 1) {
                handlePageChange(currentPage - 1);
            }
        };

        const goToNextPage = () => {
            if (currentPage < totalPages) {
                handlePageChange(currentPage + 1);
            }
        };

        return (
            <div className="pagination">
                <button
                    onClick={goToPreviousPage}
                    disabled={currentPage === 1}
                    className="pagination-arrow-left"
                    aria-label="Previous page"
                >
                    <i className="fas fa-chevron-left"></i>
                </button>

                {[...Array(totalPages)].map((_, idx) => (
                    <button
                        key={idx + 1}
                        onClick={() => handlePageChange(idx + 1)}
                        className={`pagination-number ${currentPage === idx + 1 ? 'active' : ''}`}
                        aria-label={`Page ${idx + 1}`}
                        aria-current={currentPage === idx + 1 ? 'page' : undefined}
                    >
                        {idx + 1}
                    </button>
                ))}

                <button
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                    className="pagination-arrow-right"
                    aria-label="Next page"
                >
                    <i className="fas fa-chevron-right"></i>
                </button>
            </div>
        )
    }



    return (
        <PageLayout className={`blog-page ${className}`} activeSection={activeSection} inferSearchSection={activeSection !== SECTIONS.VISITOR.key} sitemap={sitemap}>
            {blog && (
                <Fragment>
                    <Helmet>
                        <title>{blog.title}</title>
                        {description && <meta name="description" content={description} />}
                    </Helmet>

                    <main className="wrapper flex-column container-fluid blog-container">
                        {/* Blog Header Section */}
                        <section className="section row narrow">
                            <div className="">
                                <h1 className="blog-title">{blog.title}</h1>
                                {description && <p className="blog-description">{description}</p>}
                            </div>
                        </section>

                        {blog.articles && blog.articles.length > 0 && (
                            <section className="section row narrow">
                                {
                                    currentPage === 1 && (
                                        <div className="col-12 padding-0">
                                            <BlogLinkWidget key={firstArticle.contentful_id} data={firstArticle} />
                                        </div>
                                    )
                                }
                                <div className="col-12">



                                    <div className={`articles-grid ${currentPage === 1 ? 'mt-28' : ''}`}>
                                        {map(currentArticles, (article, index) => (
                                            <BlogStoryBlockWidget key={article.contentful_id || index} data={article} />
                                        ))}
                                    </div>
                                    {renderPagination()}
                                </div>
                            </section>
                        )}
                    </main>
                </Fragment>
            )}
        </PageLayout>
    )
}
